export default class MappingsModel {
  practice: number;
  title: number;
  glOffice: number;
  office: number;
  glAccount: number;
  public constructor() {}
}
